<template>
  <div class="faqs">
    <div class="get-the-loan">
      <!-- What do I need for my loan? -->
      <h4 class="heading-h4">What do I need for my loan?</h4>

      <BlackIconList :listItems="listItems1" />

      <!-- Get your 2nd loan  -->
      <h4 class="heading-h4 mt-n5">Get your 2nd loan</h4>

      <BlackIconList :listItems="listItems2" />

      <!-- How quick will I get my money? -->
      <h4 class="heading-h4 mt-n5">How quick will I get my money?</h4>

      <p class="b-body-1">
        When your loan is approved, instruction is sent to our bank to pay your
        loan. Note that when your loan is approved before 2 pm Monday - Friday,
        it forms part of the 2 pm payout cycle and should reflect in your bank
        within 12 hours. If the loan is approved after 2 pm, your loan will be
        part of the next day's 2 pm payout cycle and should reflect in your
        account 12 hours later. If your loan is approved after 2 pm on a Friday
        but before 7 am on a Saturday morning, it will form part of the Saturday
        7 am payout cycle.
      </p>

      <!--Why am I required to provide documents? -->
      <h4 class="heading-h4">Why am I required to provide documents?</h4>

      <p class="b-body-1">
        We are bound by the National Credit Act to do an affordability
        assessment to prevent reckless credit granting. To enable us to do this,
        we need to verify income and expenses of all our customers.
      </p>

      <!-- Is it safe to provide my bank account details? -->
      <h4 class="heading-h4">Is it safe to provide my bank account details?</h4>

      <p class="b-body-1">
        It is extremely safe! Our website does not store any personal
        information, and our Loan Management System is cloud-based and access
        secured by Two-Factor Authentication (2FA) and a complete audit trail of
        access.
      </p>

      <!-- Why was my application declined?    -->
      <h4 class="heading-h4">Why was my application declined?</h4>

      <p class="b-body-1">
        There could be many reasons why a loan is declined. Some examples are;
        affordability, poor credit history, debt review, salary to low etc.
      </p>

      <!-- DebiCheck process flow diagram    -->
      <h4 class="heading-h4">DebiCheck process flow diagram</h4>

      <v-img
        alt="debicheck"
        class="debicheck hidden-xs-only"
        contain
        src="@/assets/img/public/pages/faqs/debicheck.png"
        max-width="770"
      />
    </div>
  </div>
</template>

<script>
import BlackIconList from "@/components/shared/lists/BlackIconList";

export default {
  name: "LimeLoansGettheloantab",

  components: { BlackIconList },

  data() {
    return {
      listItems1: [
        {
          text: `SA ID Number`,
        },
        {
          text: `Your cellphone number`,
        },
        {
          text: `Your email address`,
        },
        {
          text: `Your bank account details`,
        },
        {
          text: `Your employment details`,
        },
        {
          text: `Your latest 3-month bank statement showing your most recent 3 salary deposits`,
        },
      ],
      listItems2: [
        {
          text: `Press “Log in” button, enter the mobile number that you used to
                register with`,
        },
        {
          text: `Verify your personal data and bank account details`,
        },
        {
          text: `Confirm your gross income, your latest net salary that appears
           on your bank statement and complete your monthly living expenses. Then
            upload your most recent 3 months bank statement showing your most recent 3 salary deposits.`,
        },
        {
          text: `Choose your required loan value and repayment term`,
        },
        {
          text: `Read your Pre-Agreement and Quotation and your Loan
           Agreement then sign electronically by clicking on “Get SMS Code”, lastly 
           request and authorise your DebiCheck debit order.`,
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  .b-body-1 {
    //styleName: 14 S/normal;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.01em;
  }
}
</style>
